import { base } from "../bot-loaders";



export async function uploadExcelFile(file:File){
    const form = new FormData();
    form.append("file", file)

    const res = await fetch(`${base}parse-file`, {
        method: 'post',
        body: form
    })

    if(res.status != 200) throw 'error'

    return await res.json()
}